import { render, staticRenderFns } from "./sacnnerDashboard.vue?vue&type=template&id=5ca4c415"
import script from "./sacnnerDashboard.vue?vue&type=script&lang=js"
export * from "./sacnnerDashboard.vue?vue&type=script&lang=js"
import style0 from "./sacnnerDashboard.vue?vue&type=style&index=0&id=5ca4c415&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports